export const inquiryDetail_cn = {
  title: '询盘详情',
  report: '投诉',
  reported: '已投诉',
  release: '发布时间',
  countdown: '倒计时',
  freight_type: '业务类型',
  cargo_type: '货物类型',
  from: '货物始发地',
  to: '货物目的地',
  commodity: '品名',
  remark: '备注',
  remark_placeholder: '请输入备注',
  publisher_info_tx1: '询盘方信息',
  publisher_info_tx2: '发布用户非JCtrans国际会员联盟会员，不享受合作风险保障服务，请谨慎合作',
  publisher_info_tx3: '当前发布用户为非会员，请谨慎合作',
  company_rating: '公司评分',
  no_score: '暂无评分',
  remaining_quotes: '本月剩余报价次数',
  remaining_quotes1: '次',
  not_matched: '不匹配',
  FillInTheRespond: '填写报价',
  respond: '参考报价',
  respond_btn: '报价',
  Price: '参考报价',
  check_Price: '请输入合理的报价数值',
  expires: '会员有效期',
  find: '寻找',
  score_okay: '中',
  score_great: '高',
  score_unsatisfied: '低',
  fromEnd: '距结束:',
  quoted: '已报价',
  timeOut: '已超时',
  rejected: '已拒绝',
  agent: '代理',
  individual: '个',
  image: '图片',
  pop_finish: '此询盘已结束',
  pop_match: '您当前与目标国家/区域不符，不能进行报价',
  pop_quoted: '此派单已报价',
  pop_over: '此派单已超时',
  pop_rejected: '此派单已拒绝',
  authentication: '去认证',
  trail_btn: '申请试用',
  abanden_btn: '暂不申请',
  trail_wait: 'JCtrans已收到您的试用申请，请等待审核',
  cancel: '取消',
  trade: '货主',
  account_mismatch: '账号归属公司与链接不符无权查看，请切换账号',
  sorry: '抱歉，当前询盘已删除',
  to_hall: '询盘大厅',
  more_change: '去询盘大厅逛逛，获取更多机会',
  no_permission: '抱歉，供应商无报价权限',
  check_close: '询盘方手动关闭询盘',
  check_complete: '询盘已应满或已确认合作方',
  check_expired: '询盘已超过72H，未应满自动关闭',
  trail_btn1: '成为会员',
  quotation_validity_period: '报价有效期',
  quotation_validity_period_p: '请选择报价有效期',
  contact: '联系人',
  contact_placeholder: '请输入联系人',
  phone: '手机号',
  phone_placeholder: '请输入手机号',
  email: '邮箱',
  email_placeholder: '请输入邮箱',
  placehholderRemark: '请输入备注信息，最多不超过1000字符',
  not_vip_tips: '此发盘人非JCtrans会员，不享受合作风险保障服务。请您仔细甄别对方身份，评估合作风险，谨慎合作，以免造成不必要的损失。',
  not_naVip_tips: '发布用户非JCtrans国际会员联盟会员，不享受合作风险保障服务，请谨慎合作',
  open_vip_title: '开通会员',
  open_vip_content: '暂无权限，请前往开通会员获取更多权益',
  open_vip: '去开通',
  price_placeholder: '请输入报价金额',
  price_placeholder1: '请输入正确的报价金额',
  curreny_placeholder: '币种不能为空',
  time_placeholder: '报价有效期不能为空',
  times_explain: '报价次数说明',
  times_decision: '报价次数由您的会员身份决定',
  ok: '我知道了',
  sure: '确定',
  report_Sorry2: '抱歉，您已投诉过该询盘',
  curreny_p1: '币种',
  currency_p: '请选择币种',
  currency_c: '选择币种',
  remark_p: '备注不能为空',
  cargo_type_input: '请选择货物类型',
  filters: '筛选',
  form_CargoType: '货物类型',
  NationalityChina: '国内同行',
  NationalityCountry: '海外同行',
  inquiryPerson: '询盘方身份',
  postCardText: '有走货需求？',
  postCardBtn: '发盘询价',
  bulk: '散货',
  Respond_mobile_m2: '请正确输入您的手机号',
  is_chinese1: '业务双方国家/区域涉及海外，只允许填写英文。错误文本为“{',
  is_chinese2: '}”',
  susMy_tips: '抱歉，贵司已被暂停，无法使用此功能',
  inquiryRespond_check_queue: '此询盘已过可加塞期限，不可报价！',
  // 加塞
  jump_queue_title: '启用加塞特权',
  jump_queue_status: '该货盘状态为',
  jump_queue_expired: '已过期',
  jump_queue_filled: '应满',
  use_jump: '，您是否要使用',
  jump_queue: '加塞特权？',
  jump_queue_have: ' 公司加塞权益剩余：',
  jump_queue_num: ' 次',
  must_curreny: '价格存在时，必须选择币种',
  must_price: '币种存在时，价格必须填写',
  offer_detele1: '询盘已被删除',
  go_app: '前往',
  app: ' JCtrans APP ',
  app_more: '查看海量商机',
  tips: '提示',
  qq_email: '请输入邮箱，不支持QQ邮箱',
  wcc_obtain: '请先获取验证码',
  offer_success: '报价成功！',
  isCreditSettle: '支持平台信保结算',
  isCreditSettle_need: '需要',
}

export const inquiryDetail_en = {
  remark_p: 'Remark cannot be left blank.',
  currency_c: 'Select the currency',
  currency_p: 'Select',
  title: 'Detail',
  report: 'Report',
  reported: 'Reported',
  release: 'Release',
  countdown: 'Countdown',
  freight_type: 'Freight Type',
  cargo_type: 'Cargo Type',
  from: 'From',
  to: 'To',
  commodity: 'Commodity',
  remark: 'Remark',
  remark_placeholder: 'Please enter remark',
  publisher_info_tx1: 'Publisher Information',
  publisher_info_tx2: 'Attention! The cooperation will not be under JCtrans Cooperation Risk Protection due to their non-member status.',
  publisher_info_tx3: 'The inquiry comes from a non-member, please careful cooperation.',
  company_rating: 'Company rating',
  no_score: 'No Score',
  remaining_quotes: 'Remaining Quotes This Month ',
  remaining_quotes1: ' time',
  not_matched: 'Not Matched',
  FillInTheRespond: 'Fill in the respond',
  respond: 'Reference Quote',
  respond_btn: 'Respond',
  Price: 'Reference Quote',
  check_Price: 'Please enter a reasonable quotation value',
  expires: 'Expires',
  find: 'Looking for',
  score_okay: 'Okay',
  score_great: 'Great',
  score_unsatisfied: 'Unsatisfied',
  fromEnd: 'Count down:',
  quoted: 'respond',
  timeOut: 'Timed out',
  rejected: 'Rejected',
  agent: 'agents',
  individual: '',
  pop_finish: 'The Inquiry has finished',
  pop_match: 'Unable to reply due to target country/region mismatch',
  pop_quoted: 'The inquiry is timed out',
  pop_over: 'You have already quoted the inquiry',
  pop_rejected: 'The inquiry has been rejected',
  authentication: 'Activate',
  trail_btn: 'Apply for Trail',
  abanden_btn: 'Waive to Quote',
  trail_wait: 'JCtrans has received your trial application, please wait the audit result',
  cancel: 'Cancel',
  trade: 'Trade',
  account_mismatch: "Sorry, the account attribution company isn't authorized to view it, please change the account.",
  sorry: 'Sorry, the current inquiry has been deleted',
  to_hall: 'Inquiry Board',
  more_change: 'View the inquiry board to browse more opportunities',
  no_permission: 'Sorry, vedors have no permission to quotation',
  check_close: 'The inquiry is closed by the poster.',
  check_complete: 'The poster has made a selection or the respond space is full.',
  check_expired: 'The inquiry has expired within 72 hours and was automatically closed.',
  trail_btn1: 'Join Us',
  quotation_validity_period: 'Quotation Validity Period',
  quotation_validity_period_p: 'Select the quotation validity period',
  contact: 'Contact',
  contact_placeholder: 'Please enter your contact',
  phone: 'Mobile',
  phone_placeholder: 'Please enter your mobile',
  email: 'E-mail',
  email_placeholder: 'Please enter your E-mail',
  placehholderRemark: 'Please enter the description of your inquiry with maximum length of 1000 characters',
  not_vip_tips: "The post comes from a non-member.This cooperation doesn't enjoy the cooperation risk protection service.It is recommended to be careful and avoid unnecessary losses.",
  not_naVip_tips: 'Attention! The cooperation will not be under JCtrans Cooperation Risk Protection due to their non-member status.',
  open_vip_title: 'Become a member',
  open_vip_content: 'No permission. Please subscribe to a membership to access more benefits.',
  open_vip: 'Become a member',
  price_placeholder: 'Please enter price',
  price_placeholder1: 'Please enter the correct price',
  curreny_placeholder: 'Please enter currency',
  time_placeholder: 'Please enter quotation validity period',
  times_explain: 'Quote times explanation',
  times_decision: 'Your quote times are determined by your membership status',
  ok: 'OK',
  sure: 'Confirm',
  report_Sorry2: 'Sorry, you have reported this inquiry.',
  curreny_p1: 'Currency',
  cargo_type_input: 'Please select cargo type',
  filters: 'Filters',
  form_CargoType: 'Cargo Type',
  NationalityChina: 'China Local',
  NationalityCountry: 'Overseas Peers',
  inquiryPerson: `Poster's membership`,
  postCardText: 'Need a quote ?',
  postCardBtn: 'Post Now',
  bulk: 'Bulk',
  Respond_mobile_m2: 'Please enter the correct phone number!',
  is_chinese1: 'Only English is allowed due to the countries/regions of both business parties involve overseas.Error text:',
  is_chinese2: '',
  susMy_tips: 'Sorry, your company has been suspended, can not use this function',
  inquiryRespond_check_queue: "Inquiry privilege period has ended. You can't quote now, but check other opportunities!",
  // 加塞
  jump_queue_title: 'Enable Inquiry Privilege',
  jump_queue_status: 'The inquiry is currently ',
  jump_queue_expired: 'Expired',
  jump_queue_filled: 'Filled',
  use_jump: ' , would you like to use ',
  jump_queue: 'Inquiry Privilege?',
  jump_queue_have: '  Inquiry Privilege Remaining: ',
  jump_queue_num: ' ',
  must_curreny: 'Currency must be selected when amount exists',
  must_price: 'Amount must be entered when currency exists',
  offer_detele1: 'The inquiry has been deleted',
  go_app: 'Go to',
  app: ' JCtrans APP ',
  app_more: 'to view numerous business opportunities',
  tips: 'Tips',
  qq_email: 'Please enter email, excluding QQ email',
  wcc_obtain: 'Please obtain the verification code',
  offer_success: 'Quote Submitted!',
  isCreditSettle: 'Support Credit Assurance Settlement',
  isCreditSettle_need: 'Need',
}